// Modal component to edit a task.
//
// props.task is the task to edit.
// props.item is the Item the task belongs to.
// props.save is an async function that is called when save is tapped.
// props.delete is an async function that is called when delete is tapped.
// props.show is used to show/hide the UI.
// props.onHide is a function used to hide the UI.

import { taskFields } from '../fleet-shared/TaskFields.mjs';
import { buildFieldsForItem } from '../fleet-shared/Common.mjs'
import { validateTask } from '../utilities/Validators.mjs';
import ModalEditForm from './ModalEditForm';

function EditTask(props) {
  async function handleDelete() {
    await props.delete(props.task.id);
  }
  // Note: `show` is forwarded to the underlying ModalEditForm/Modal, but the
  // modal only mounts when `props.task` is non-null (the guard below). To open
  // it, set BOTH the task and show together -- see `useEditTaskPopup`'s
  // `showEditTaskPopup`, which calls setEditTask(task) and setShowEditTask(true).
  //
  // recordKeyPrefix "task" shares the autosave lane with every other editor
  // of the same task (Task.jsx, LogbookUpdateTask's radios) so their writes
  // serialize instead of racing.
  return (
    (props.task != null) &&
    <ModalEditForm
      show={props.show}
      onHide={props.onHide}
      fields={buildFieldsForItem(taskFields, props.item)}
      item={props.task}
      save={props.save}
      delete={handleDelete}
      validate={validateTask}
      recordKeyPrefix="task"
    />
  );
}

export default EditTask;
